import { useEffect } from "react";
import styles from "./FooterPoup.module.scss";

export const FooterPopup = ({
  text,
  destroyFooterPopup,
  timer = 1000,
  theme,
}) => {
  useEffect(() => {
    setTimeout(() => {
      destroyFooterPopup(false);
    }, timer);
  }, []);

  return <div className={styles.footer_popup_container}>{text}</div>;
};
